<template>
  <div data-app>
    <div class="container-fluid">
      <!-- 1°first ROW -->
      <div class="row">
        <div class="col-md-12">
          <!-- 1°first Card -->
          <div class="card">
            <div class="card-header">
              Detalle del Tipo de Movimiento
              <v-tooltip top>
                <template v-slot:activator="{ on}">
                  <span v-on="on" class="badge badge-primary badge-pill float-right sdw">
                    <i class="fa fa-paste text-white"></i>
                  </span>
                </template>
                <span>Detalle del Tipo de Movimiento</span>
              </v-tooltip>
              <!--<v-tooltip bottom>
                <template v-slot:activator="{ on}">
                  <span
                    v-on="on"
                    class="badge badge-danger badge-pill float-right sdw mr-3"
                    @click="eliminate()"
                  >
                    <i class="fas fa-trash text-white"></i>
                  </span>
                </template>
                <span>ELiminar Razón</span>
              </v-tooltip>-->
              <v-tooltip top>
                <template v-slot:activator="{ on}">
                  <span
                    v-on="on"
                    class="badge badge-warning badge-pill float-right sdw mr-3 pointer"
                    @click="dialog = true"
                  >
                    <i class="fas fa-edit text-dark"></i>
                  </span>
                </template>
                <span>Editar Tipo de Movimiento</span>
              </v-tooltip>
            </div>
            <div class="card-body">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <ul class="list-group mb-3">
                      <h4 class="d-flex justify-content-between align-items-center mb-3">
                        <span class="text-muted">{{reason.name}}</span>
                        <span class="badge badge-secondary badge-pill">ID: {{id}}</span>
                      </h4>
                      <li class="list-group-item d-flex justify-content-between lh-condensed">
                        <div>
                          <h6 class="my-0">Tipo de Movimiento: {{reason.name}}</h6>
                          <small class="text-muted">Acción o Motivo.</small>
                        </div>
                        <div>
                          <span class="badge badge-secondary badge-pill float-right">
                            <i class="fa fa-paste"></i>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
                <!--Dialog--->
                <v-dialog v-model="dialog" width="800" persistent>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-card>
                          <v-card-title>Edítar Tipo de Movimiento</v-card-title>
                          <v-divider></v-divider>
                          <v-container>
                            <v-form ref="form" v-model="valid" lazy-validation>
                              <v-row>
                                <v-col cols="12" sm="2" md="2">
                                  <v-text-field
                                    v-model="reason.id"
                                    name="id"
                                    readonly="readonly"
                                    label="ID"
                                    filled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="9" md="9" offset-md="1">
                                  <v-text-field
                                    v-model="reason.name"
                                    :rules="[v => !!v || 'Ingresar un tipo de movimiento, es requerido!']"
                                    label="Tipo de movimiento"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-form>
                          </v-container>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="#FFD700"
                              class="mx-2"
                              fab
                              dark
                              small
                              @click="editReason()"
                            >
                              <v-icon color="#000000" dark>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              class="mx-2"
                              fab
                              dark
                              small
                              color="#FF6347"
                              @click="dialog = false"
                            >
                              <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-dialog>
                <!--End Dialog--->
              </v-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card:hover,
.sdw {
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14),
    0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.3);
  color: black;
}
.pointer {
  cursor: pointer;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

export default {
  props: ["id"],
  data: () => ({
    boolean: false,
    dialog: false,
    valid: true,
    dateMsg:
      new Date().toISOString().substr(0, 10) +
      " " +
      new Date().toISOString().substr(11, 5),
    reason: {
      id: 0,
      name: "Def",
    },
  }),
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "➀ Tipo de movimiento", route: "/inventario/reasons" },
      { title: "➁ Detalle Tipo de movimiento", route: `/inventario/reasons/${this.id}` },
    ]);
  },
  created() {
    this.fetchReason();
  },
  methods: {
    initialize() {},
    close() {
      this.dialog = false;
    },
    editReason() {
      var vm = this;

      if (!vm.reason.name.length || vm.reason.name == null) {
        vm.$bvToast.toast("El tipo de movimiento, no debe ir vacío!", {
          title: `Formulario Invalido`,
          variant: "danger",
          solid: true,
          toaster: "b-toaster-bottom-center",
        });
        vm.$refs.form.$el[1].focus();
        return;
      }
      if (this.$refs.form.validate()) {
        this.axios({
          url: "inventory/reasons/" + vm.reason.id,
          method: "PUT",
          data: {
            name: vm.reason.name,
          },
        })
          .then((response) => {
            vm.fetchReason();
            vm.$bvToast.toast(
              `El tipo de movimiento: ${vm.reason.name}, ha sido Actualizado el ${vm.dateMsg} exitosamente!`,
              {
                title: `Información`,
                variant: "success",
                solid: true,
                toaster: "b-toaster-bottom-center",
              }
            );
          })
          .catch((error) => {
            console.log(error);
          });
      }

      this.close();
    },
    eliminate() {
      var vm = this;

      const confirmacion = confirm(
        `Esta seguro de eliminar el tipo de movimiento: ${vm.reason.name} || ID: ${vm.reason.id}?`
      );
      if (confirmacion) {
        //set to localStorage to persist alert data on the redirected route
        localStorage.setItem(
          "deleteReaseon",
          JSON.stringify({
            id: vm.id,
            name: vm.reason.name,
          })
        );

        this.axios({
          url: "inventory/reasons/" + vm.reason.id,
          method: "DELETE",
        })
          .then((response) => {
            vm.$bvToast.toast(
              `El tipo de movimiento: ${vm.reason.name} ha sido eliminada, el ${vm.dateMsg} exitosamente!`,
              {
                title: `Información`,
                variant: "success",
                solid: true,
                toaster: "b-toaster-bottom-center",
              }
            );
            //rediect to reasons
            vm.$router.push("/inventory/reasons");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    fetchReason() {
      var vm = this;
      this.axios({
        url: "inventory/reasons/" + vm.id,
        method: "GET",
      })
        .then((response) => {
          vm.reason = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>